import _ from 'lodash';
import nxModule from 'nxModule';

const templateUrl = require('./batch-loans-individual.template.html');
nxModule.component('batchIndividualLoans', {
  templateUrl: templateUrl,
  bindings: {
    batches: '<',
  },
  controller: function ($route, $location, groupCustomerCache) {
    let that = this;
    that.loans = [];

    that.openLoan = (loan) => {
      groupCustomerCache.evict();
      $location.path(`/customer/${loan.customerId}/loans/${loan.id}`)
    };

    that.$onChanges = changes => {
      let currentBatches = changes.batches.currentValue;
      if (currentBatches) {
        currentBatches = currentBatches.filter(b => b.loans && b.loans.length > 0);
        let loans = _.flatten(currentBatches.map(batch => batch.loans));
        // sort so that CLOSED is at the end of the list
        that.loans = _.sortBy(loans, (l) => l && l.status === 'CLOSED' ? 1 : 0)
      } else {
        that.loans = [];
      }
    }
  }
});